import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--foreground-critical, #cb101d);
  justify-content: space-between;
  margin: 24px 0;
`

export const Label = styled.div`
  margin-top: 8px;
  font-weight: 400;
  color: var(--foreground-neutral, #4d5874);
  text-align: center;
`
